var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 515086"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M40 20C40 31.045 31.045 40 20 40C8.955 40 0 31.045 0 20C0 8.955 8.955 0 20 0C31.045 0 40 8.955 40 20Z",
    fill: "url(#paint0_linear_3972_11403)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20 0C8.955 0 0 8.955 0 20H20V0Z",
    fill: "url(#paint1_linear_3972_11403)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17 18C17.5523 18 18 17.5523 18 17C18 16.4477 17.5523 16 17 16C16.4477 16 16 16.4477 16 17C16 17.5523 16.4477 18 17 18Z",
    fill: "#99F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13 18C13.5523 18 14 17.5523 14 17C14 16.4477 13.5523 16 13 16C12.4477 16 12 16.4477 12 17C12 17.5523 12.4477 18 13 18Z",
    fill: "#99F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9 18C9.55228 18 10 17.5523 10 17C10 16.4477 9.55228 16 9 16C8.44772 16 8 16.4477 8 17C8 17.5523 8.44772 18 9 18Z",
    fill: "#99F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M5 18C5.55228 18 6 17.5523 6 17C6 16.4477 5.55228 16 5 16C4.44772 16 4 16.4477 4 17C4 17.5523 4.44772 18 5 18Z",
    fill: "#99F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M15 14C15.5523 14 16 13.5523 16 13C16 12.4477 15.5523 12 15 12C14.4477 12 14 12.4477 14 13C14 13.5523 14.4477 14 15 14Z",
    fill: "#99F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M11 14C11.5523 14 12 13.5523 12 13C12 12.4477 11.5523 12 11 12C10.4477 12 10 12.4477 10 13C10 13.5523 10.4477 14 11 14Z",
    fill: "#99F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M7 14C7.55228 14 8 13.5523 8 13C8 12.4477 7.55228 12 7 12C6.44772 12 6 12.4477 6 13C6 13.5523 6.44772 14 7 14Z",
    fill: "#99F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M3 14C3.55228 14 4 13.5523 4 13C4 12.4477 3.55228 12 3 12C2.44772 12 2 12.4477 2 13C2 13.5523 2.44772 14 3 14Z",
    fill: "#99F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M17 10C17.5523 10 18 9.55228 18 9C18 8.44772 17.5523 8 17 8C16.4477 8 16 8.44772 16 9C16 9.55228 16.4477 10 17 10Z",
    fill: "#99F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M13 10C13.5523 10 14 9.55228 14 9C14 8.44772 13.5523 8 13 8C12.4477 8 12 8.44772 12 9C12 9.55228 12.4477 10 13 10Z",
    fill: "#99F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M9 10C9.55228 10 10 9.55228 10 9C10 8.44772 9.55228 8 9 8C8.44772 8 8 8.44772 8 9C8 9.55228 8.44772 10 9 10Z",
    fill: "#99F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M17 2C17.5523 2 18 1.55228 18 1C18 0.447715 17.5523 0 17 0C16.4477 0 16 0.447715 16 1C16 1.55228 16.4477 2 17 2Z",
    fill: "#99F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M13.0001 1.99983C13.5521 1.99983 14.0001 1.55183 14.0001 0.999828C14.0001 0.972828 13.9871 0.950828 13.9851 0.923828C13.3791 1.11483 12.7851 1.33083 12.2051 1.57683C12.3871 1.82683 12.6671 1.99983 13.0001 1.99983Z",
    fill: "#99F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M5 10C5.55228 10 6 9.55228 6 9C6 8.44772 5.55228 8 5 8C4.44772 8 4 8.44772 4 9C4 9.55228 4.44772 10 5 10Z",
    fill: "#99F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M15 6C15.5523 6 16 5.55228 16 5C16 4.44772 15.5523 4 15 4C14.4477 4 14 4.44772 14 5C14 5.55228 14.4477 6 15 6Z",
    fill: "#99F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M11 6C11.5523 6 12 5.55228 12 5C12 4.44772 11.5523 4 11 4C10.4477 4 10 4.44772 10 5C10 5.55228 10.4477 6 11 6Z",
    fill: "#99F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M7.00041 6.00048C7.55241 6.00048 8.00041 5.55248 8.00041 5.00048C8.00041 4.71048 7.87241 4.45448 7.67541 4.27148C7.15941 4.67648 6.66441 5.10348 6.19141 5.55648C6.37141 5.81848 6.65841 6.00048 7.00041 6.00048Z",
    fill: "#99F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M0.999945 18C1.55195 18 1.99995 17.552 1.99995 17C1.99995 16.448 1.55195 16 0.999945 16C0.754945 16 0.537945 16.098 0.363945 16.245C0.283945 16.666 0.221945 17.094 0.168945 17.524C0.345945 17.803 0.643945 18 0.999945 18Z",
    fill: "#99F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M40.0003 20H20.0003V16H39.5983C39.8613 17.293 40.0003 18.63 40.0003 20ZM8.03734 36H31.9633C33.4823 34.862 34.8313 33.517 35.9723 32H4.02834C5.16934 33.517 6.51834 34.862 8.03734 36ZM20.0003 0V4H31.9633C28.6243 1.499 24.4923 0 20.0003 0ZM35.9723 8H20.0003V12H38.3243C37.6983 10.568 36.9013 9.233 35.9723 8ZM1.67634 28H38.3253C38.8813 26.729 39.3163 25.393 39.5993 24H0.402344C0.685344 25.393 1.12034 26.729 1.67634 28Z",
    fill: "url(#paint2_linear_3972_11403)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3972_11403",
    x1: 6.377,
    y1: 6.377,
    x2: 34.577,
    y2: 34.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE9F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#9EA7B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3972_11403",
    x1: 5.741,
    y1: 5.741,
    x2: 33.927,
    y2: 33.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D61A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16528C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3972_11403",
    x1: 5.70134,
    y1: 5.841,
    x2: 34.7003,
    y2: 34.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB3542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#BA0B1A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsFlag);
export default __webpack_public_path__ + "static/media/usFlag.19477dc95993af249fd6ef4c10ffa0a7.svg";
export { ForwardRef as ReactComponent };